import Constants from 'Components/ContractGenerator/shared/constants';
import useValidation from 'Components/ContractGenerator/shared/helpers/useValidation';
import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { contractGeneratorOperations, contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';
import Icon from 'ViatoUi/Shared/DataDisplay/Icon';
import ValidationError from 'ViatoUi/Shared/Feedback/ValidationError';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';
import Button from 'ViatoUi/Web/FormElements/Buttons/Button';

const ButtonStep2 = () => {
	const { t } = useTranslation('contractGenerator');
	const dispatch = useDispatch();

	const [showPopup, setShowPopup] = useState(false);

	const windowWidth = useSelector(contractGeneratorSelectors.getWindowWidth);
	const blockedFields = useSelector(contractGeneratorSelectors.getBlockedFields);
	const backIsDisabled = blockedFields?.selectedRooms && blockedFields?.selectedContractTermInMonths && blockedFields?.selectedProduct;

	const { validationErrors } = useValidation();

	return (
		<>
			{!backIsDisabled && (
				<>
					<Button type='slate' onClick={() => dispatch(contractGeneratorOperations.setActiveStep(Constants.STEPS.STEP1))}>
						{windowWidth > 940 || windowWidth <= 690 ? (
							t('app.userActions.back')
						) : (
							<Icon color='bright' icon='fa-angle-left' iconWeight='far' size='xl' />
						)}
					</Button>
					<Spacer width='m' />
				</>
			)}
			<Button
				type='secondary'
				onClick={() => {
					if (validationErrors.length > 0) {
						setShowPopup(true);
					} else {
						dispatch(contractGeneratorOperations.setActiveStep(Constants.STEPS.STEP3));
					}
				}}
			>
				{windowWidth > 940 || windowWidth <= 690 ? t('app.userActions.toSummary') : t('app.userActions.summary')}
			</Button>
			{process.env.NODE_ENV !== 'production' && (
				<div
					role='button'
					style={{ position: 'fixed', top: '10px', right: '10px', zIndex: 999999999, color: 'red' }}
					tabIndex={0}
					onClick={() => {
						dispatch(
							contractGeneratorOperations.setDataToSubmit({
								selectedPaymentType: 'monthly',
								formData: {
									company: {
										startOfContract: { value: '29.01.2022', key: 1643449220000 },
										companyName: 'Bär GmbH',
										taxId: 'DE 123 123',
										companyRegistrationNo: 'HRB 123 123',
										email: 'm.wernet@viato.net',
										iban: 'DE51 1203 0000 1072 0167 34',
										bic: 'BYLADEM1001',
										bank: 'DKB Deutsche Kreditbank AG'
									},
									contact: {
										propertyName: 'Hotel Am Mettweg',
										customerSalutation: {
											value: 'Herr',
											key: 'mr'
										},
										customerFirstName: 'Michael',
										customerLastName: 'Wernet',
										streetNameAndNo: 'Am Mettweg 10',
										zipAndCity: '79111 Freiburg',
										country: 'Deutschland',
										phone: '08761231',
										email: 'm.wernet@viato.net',
										isDifferentBillingAddress: false
									}
								}
							})
						);
						dispatch(contractGeneratorOperations.deleteKey(`userInput.fieldInfo.formData.company`));
						dispatch(contractGeneratorOperations.deleteKey(`userInput.fieldInfo.formData.contact`));
					}}
				>
					fill
				</div>
			)}
			<ValidationError setShowPopup={setShowPopup} showPopup={showPopup} />
		</>
	);
};

export default ButtonStep2;
